import { logger } from '@/lib/logger';
import { features } from '@/lib/features';

/**
 * Moved over from Email.jsx, so I did not alter current code / instrumentation
 */

const getCommonPayload = () => {
  const forced_signup_offered = features.isActive('isForcedSignUp') ? 1 : 0;

  return {
    existingAccountCheck: {
      event_name: 'xo_guest_existing_account_check',
      field_name: 'email',
      forced_signup_offered,
      state_name: 'existing_account_check',
    },
    forced_signup_offered,
  };
};

export const logEmailLookupCompleted = (isExistingAccount: boolean): void => {
  logger.fpti('is_existing_account_email_check_onCompleted', {
    ...getCommonPayload().existingAccountCheck,
    buyer_type: isExistingAccount ? 'existing_account' : 'new_account',
    transition_name: 'process_existing_account_check',
  });
};

export const logEmailLookupError = (message: string): void => {
  logger.fpti('is_existing_account_email_check_onError', {
    ...getCommonPayload().existingAccountCheck,
    int_error_desc: message || 'EXISTING_ACCOUNT_CHECK_ERROR',
  });
};

export const logEmailLookupStart = (): void => {
  logger.fpti('is_existing_account_email_check_onStart', {
    ...getCommonPayload().existingAccountCheck,
    transition_name: 'prepare_existing_account_check',
  });
};
